module.exports = __webpack_public_path__ + "img/69a595bb-3822-466b-9db7-b8f804570919.4f480f20.png";